var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "animate-circle",
    cx: 40,
    cy: 39.8,
    r: 20,
    fill: "#A6B2EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.4605 40C77.5199 40 80.0394 37.5081 79.6171 34.478C78.6961 27.8709 76.1323 21.5678 72.1221 16.1636C67.0062 9.26944 59.808 4.20411 51.5914 1.71632C43.3747 -0.771473 34.5757 -0.549713 26.4949 2.34882C18.414 5.24735 11.4801 10.6689 6.71799 17.812C1.9559 24.9551 -0.381674 33.4409 0.0507822 42.0149C0.483239 50.589 3.66277 58.7965 9.11944 65.4242C14.5761 72.0519 22.0203 76.7482 30.3518 78.819C36.8827 80.4422 43.687 80.3845 50.1401 78.6934C53.0996 77.9179 54.4307 74.6337 53.254 71.8097C52.0773 68.9856 48.8341 67.7082 45.8377 68.3257C41.6236 69.1941 37.2449 69.1161 33.0242 68.067C27.0003 66.5698 21.6179 63.1743 17.6726 58.3823C13.7273 53.5903 11.4285 47.6561 11.1158 41.4569C10.8031 35.2576 12.4932 29.1222 15.9363 23.9576C19.3794 18.7929 24.3928 14.873 30.2355 12.7773C36.0781 10.6816 42.44 10.5213 48.3808 12.32C54.3216 14.1187 59.5261 17.7811 63.225 22.7657C65.8167 26.2583 67.5729 30.2702 68.392 34.4941C68.9745 37.4976 71.4011 40 74.4605 40Z",
    fill: "#F2C94C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.460fee0368ce67d5a38d66a41904e05d.svg";
export { ForwardRef as ReactComponent };